import { ReviewItemProps } from '@zola/zola-ui/src/components/PreAuthV3/ReviewItem';

export const reviewItems: ReviewItemProps[] = [
  {
    name: 'Justin & Jesse',
    reviewText:
      'We have a large guest list and not everyone knows how we both met. Added some photos of our first date spot and how it all happened!',
    title: 'Helped us share our story',
  },
  {
    name: 'Mei & Arnold',
    reviewText:
      'Every time guests asked a question, I just directed them to our website. We had a massive FAQ section that made things so much easier!!',
    title: 'Didn’t have to answer a million texts',
  },
  {
    name: 'Jason & Ted',
    reviewText: 'As guests, we loved that everything we needed to know was in one place. Genius!',
    title: 'Zola is an absolute must',
  },
];
